module.exports = new __parcel__URL__("code-preview.15cf9a6e.svg").toString();